"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringReplace;

var _lodash = _interopRequireDefault(require("lodash"));

var _flattenObject = _interopRequireDefault(require("./flatten-object"));

var baseConfig = {
  start: "[",
  end: "]",
  separator: ".",
  prefix: null
};

function stringReplace(content, replacements, config) {
  var settings = _lodash["default"].assign({}, baseConfig, config);

  return _lodash["default"].reduce((0, _flattenObject["default"])(replacements || {}, settings.separator), function (result, value, key) {
    if (_lodash["default"].isObject(value) && !_lodash["default"].isArray(value)) {
      return stringReplace(result, value, _lodash["default"].assign({}, settings, {
        prefix: key
      }));
    }

    var baseKey = settings.prefix ? [settings.prefix, key].join(settings.separator) : key;
    var replaceKey = "".concat(settings.start).concat(baseKey).concat(settings.end).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var replaceRegexKey = new RegExp(replaceKey, "gm");
    return result.replace(replaceRegexKey, value);
  }, content);
}